// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media only screen and (min-device-width:320px) and (max-device-width:480px){[data-v-e7347c7e] .timeslotSelectorItem .text-option{margin-top:12px!important}}.p-dropdown[data-v-e7347c7e]{border:1px solid #a6a6a6!important}", ""]);
// Exports
module.exports = exports;
